var saveFileMixin  = {
    data: function () {
        
    },
    methods: {
        saveAs: function (blob, name) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        }
    }
}